import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LocalPrintService } from 'src/app/services/local-print.service';
import { FormGroup } from '@angular/forms';
import { WebApiClient } from 'src/app/services/web-api-client.service';
import { WebApiService } from 'src/app/services/web-api.service';
import { EasyNotificationService } from 'src/app/services/easy-notification.service';
import { OrderConsumptionReport, OrderConsumptionReportItem } from 'src/app/opd/opd-report/models/order-consumption-report';
import { DateHelper } from 'src/app/shared/helpers/date-helper';
import { DentalTreatmentCategoryService } from 'src/app/services/dental-treatment-category.service';
// @ts-ignore
import JSZip from 'jszip';
// import sha256 from 'crypto-js/sha256';
// import hmacSHA512 from 'crypto-js/hmac-sha512';
// import Base64 from 'crypto-js/enc-base64';

import * as CryptoJS from 'crypto-js';
// import * as archiver from 'archiver';
import * as fs from 'fs';
import { pipeline, Transform } from 'stream';
import { HcrService } from 'src/app/services/hcr-service.service';

@Component({
  selector: 'app-order-dosage',
  templateUrl: './order-dosage.component.html',
  styleUrls: ['./order-dosage.component.css']
})
export class OrderDosageComponent implements OnInit, AfterViewInit {

  sizePage = {
    width: 28.5,   //20, //cm
    height: 20   //28.5 //cm
  };
  paddingPage = {
    top: 0, //cm
    right: 0, //cm
    bottom: 0.5, //cm
    left: 0 //cm
  };

  heightPageWithoutPadding = this.convertCmtoPx(
    this.sizePage.height - (this.paddingPage.top + this.paddingPage.bottom)
  );
  elContainer;
  exportContainer;
  anchorsBlockValue;
  pageContent = [[]];     // Ex: [[0, 1, 2, 3], [4, 5]]
  pageContent2 = [[]];
  @ViewChild('reportContainer', { static: false })
  reportContainer: ElementRef<HTMLDivElement>;

  @ViewChild('reportContainer2', { static: false })
  reportContainer2: ElementRef<HTMLDivElement>;

  upperboundIndex: number = 0;
  showDoctorNameColume: boolean;
  isDental: boolean = false;
  monthStr: string = '';
  nowStr: string = '';
  timeStr: string = '';
  totalRecord: number = 0;
  pageNo: number = 1;
  _sDate: Date;
  _eDate: Date;
  orderConsumptionReport: OrderConsumptionReport;
  // 清單物件
  listItems: OrderConsumptionReportItem[] = [];
  totalSummary: number = 0;
  totalBoxSummary: number = 0;
  totalNHIAmount: number = 0;
  // api服務
  api: WebApiService;
  // 查詢條件;
  queryFormGroup: FormGroup;

  constructor(private webApiClient: WebApiClient,
    private localPrintService: LocalPrintService,
    private notification: EasyNotificationService,
    private hcrService: HcrService,
    private elementRef: ElementRef,
    private dentalCategoryService: DentalTreatmentCategoryService) {
    this.api = this.webApiClient.createHisService('Opd/OpdReport');
  }

  ngOnInit(): void {

    var st = document.createElement('style');
    st.appendChild(document.createTextNode(
      '@media print {body {margin: 0;color: #000;background-color: #fff;}}\n' +
      '.pres-report2 table{ border:0px solid black; border-collapse: collapse; }\n' +
      '.pres-report2 table td, table th { border-bottom: 1px solid black; padding-left: 5px;padding-right: 5px;}\n' +
      '.pres-report2 table tr:first-child th { border-top: 0; vertical-align: bottom; padding: 0px }\n' +
      '.pres-report2 table tr:last-child td { border-bottom: 0; }\n' +
      '.pres-report2 table tr td:first-child, table tr th:first-child { border-left: 0; }\n' +
      '.pres-report2 table tr td:last-child, table tr th:last-child { border-right: 0; }\n' +
      '@page { size: A4; margin: 0.5cm 0.5cm; }\n'
      // '#pageHeader:after { counter-increment: page; content: counter(page); }\n'
    ));
    setTimeout(() => {
      this.reportContainer.nativeElement.appendChild(st);
      this.reportContainer2.nativeElement.appendChild(st);
    }, 0);
  }

  ngAfterViewInit() {

  }

  // 取得統計期間的看診人次資料，並組出報表的html內容
  async fetchData(query: any) {
    this.elContainer = document.getElementById("container");
    this.orderConsumptionReport = new OrderConsumptionReport();
    this.nowStr = this.onGetDateString(new Date(), true);
    this.timeStr = this.onGetTimeString(new Date());
    this._sDate = query.startDate;
    this._eDate = query.endDate;
    this.isDental = query.isDental || false;
    if (query.reportType == 'doctor') {
      this.showDoctorNameColume = true;
    } else {
      this.showDoctorNameColume = false;
    }

    this.api.get('GetOrderConsumptionReport', query).subscribe(
      (data: OrderConsumptionReport) => {
        this.orderConsumptionReport = data;
        this.listItems = data.Items;
        this.totalRecord = this.listItems.filter(x => x.IsSummary == false).length;
        // 根據是否為牙科選擇不同的處理邏輯
        if (this.isDental) {
          this.insertDentalListData();
        } else {
          this.insertListData();
        }
      }
    );
  }

  // 組報表的html內容
  insertListData() {
    var html_Block = "";
    this.totalSummary = 0;
    this.totalBoxSummary = 0;
    this.totalNHIAmount = 0;
    var iPage = 0;
    var iBlock = 0;
    this.elContainer.innerHTML = this.createHTMLPage(iPage);    // 整份報表的html內容
    var html_header = this.createHTMLPageHeader(iPage);     // 頁表頭
    var html_ListerHeader = this.createHTMLListHeader();    // List欄位顯示名稱
    var html_finish = this.createHTMLFinish();              // 報表結束 -- 以下空白
    var elPageContent = document.getElementById("page-" + iPage + "-content");  // 取得某頁的content，每次查詢後會取第0頁
    // 組報表內容
    // [頁表頭][List欄位顯示名稱]
    elPageContent.innerHTML = html_header;
    var elTableContent = document.getElementById("table-" + iPage + "-content");
    elTableContent.innerHTML = html_ListerHeader;
    for (let i = 0; i < this.listItems.length; i++) {
      // 加入 List 每一筆的內容
      html_Block = this.createHTMLBlock(this.listItems[i]);
      var prevTableContent = elTableContent.innerHTML;
      elTableContent.innerHTML += html_Block;
      // 判斷是否超出頁面範圍? -> 新增一頁
      if (elPageContent.offsetHeight > this.heightPageWithoutPadding) {
        elTableContent.innerHTML = prevTableContent;
        iPage += 1;
        this.elContainer.innerHTML += this.createHTMLPage(iPage);
        elPageContent = document.getElementById("page-" + iPage + "-content");
        // [頁表頭][List欄位顯示名稱]
        html_header = this.createHTMLPageHeader(iPage);
        elPageContent.innerHTML += html_header;
        elTableContent = document.getElementById("table-" + iPage + "-content");
        elTableContent.innerHTML = html_ListerHeader;
        elTableContent.innerHTML += html_Block;

        this.pageContent[iPage] = [];
        this.pageContent[iPage].push(iBlock);
      } else {
        this.pageContent[iPage].push(iBlock);
      }
      iBlock += 1;

      if (i == this.listItems.length - 1) {
        // 最後一筆=>加上總計
        var html_Total = this.createHtmlTotalSummary();
        var prevTableContent = elTableContent.innerHTML;
        elTableContent.innerHTML += html_Total;
        // 判斷是否超出頁面範圍? -> 新增一頁
        if (elPageContent.offsetHeight > this.heightPageWithoutPadding) {
          elTableContent.innerHTML = prevTableContent;
          iPage += 1;
          this.elContainer.innerHTML += this.createHTMLPage(iPage);
          elPageContent = document.getElementById("page-" + iPage + "-content");
          // [頁表頭][List欄位顯示名稱]
          html_header = this.createHTMLPageHeader(iPage);
          elPageContent.innerHTML += html_header;
          elTableContent = document.getElementById("table-" + iPage + "-content");
          elTableContent.innerHTML = html_ListerHeader;
          elTableContent.innerHTML += html_Total;

          this.pageContent[iPage] = [];
          this.pageContent[iPage].push(iBlock);
        } else {
          this.pageContent[iPage].push(iBlock);
        }
      }
    }
    elPageContent.innerHTML += html_finish;
    this.upperboundIndex = iPage;
    for (var i = 0; i <= iPage; i++) {
      var tPage = document.getElementById("totalPage-" + i);
      tPage.innerHTML = "" + (this.upperboundIndex + 1);
    }
  }

  convertPxToCm(px) {
    return Math.round(((px * 2.54) / 96) * 100) / 100;
  }

  convertCmtoPx(cm) {
    return Math.round((cm * 96) / 2.54);
  }

  createHTMLPage(iPage) {
    return `<div class="page" id="page-` + iPage + `"
                    style="
                    height: ` + this.sizePage.height + `cm;
                    width: ` + this.sizePage.width + `cm;
                    padding-top: ` + this.paddingPage.top + `cm;
                    padding-right: ` + this.paddingPage.right + `cm;
                    padding-bottom: ` + this.paddingPage.bottom + `cm;
                    padding-left: ` + this.paddingPage.left + `cm;
                    display: block;
                    margin: 0px auto;
                    box-shadow: 0 0 0.15cm rgba(0, 0, 0, 0.15);
                    box-sizing: border-box;
                    background-color: white;
                    ">
                    <div class="content" id="page-` + iPage + `-content">
                    </div>
                </div>`;
  }

  createHTMLListHeader() {
    if (this.isDental) {
      return this.createDentalHTMLListHeader();
    }

    var doctoColumn = this.showDoctorNameColume ? "醫師名" : "診所名稱";
    return `<tr>
                    <th
                    style="text-align: left; width: 8%; border-right: 0px solid black;  border-left: 0px solid black; border-top: none; border-bottom: 5px double black;">
                     ` + doctoColumn + `
                    </th>
                    <th
                    style="text-align: left; width: 7%; border-right: 0px solid black;  border-left: 0px solid black; border-top: none; border-bottom: 5px double black;">
                    治療類別
                    </th>
                    <th
                    style="text-align: left; width: 7%; border-right: 0px solid black;  border-left: 0px solid black; border-top: none; border-bottom: 5px double black;">
                    醫令代碼
                    </th>
                    <th
                    style="text-align: left; width: 10%; border-right: 0px solid black;  border-left: 0px solid black; border-top: none; border-bottom: 5px double black;">
                    健保碼
                    </th>
                    <th
                    style="text-align: left; width: 7%; border-right: 0px solid black;  border-left: 0px solid black; border-top: none; border-bottom: 5px double black;">
                    年月
                    </th>
                    <th
                    style="text-align: left; width: 30%; border-right: 0px solid black;  border-left: 0px solid black; border-top: none; border-bottom: 5px double black;">
                    醫令名稱
                    </th>
                    <th
                    style="text-align: right; width: 7%; border-right: 0px solid black;  border-left: 0px solid black; border-top: none; border-bottom: 5px double black;">
                    健保價
                    </th>
                    <th
                    style="text-align: right; width: 7%; border-right: 0px solid black;  border-left: 0px solid black; border-top: none; border-bottom: 5px double black;">
                    總耗量
                    </th>
                    <th
                    style="text-align: right; width: 15%; border-right: 0px solid black;  border-left: 0px solid black; border-top: none; border-bottom: 5px double black;">
                    健耗額(健保金額)
                    </th>
                </tr>`;
  }

  createDentalHTMLListHeader() {
    return `<tr>
                    <th style="text-align: left; width: 6%; border-right: 0px solid black; border-left: 0px solid black; border-top: none; border-bottom: 5px double black;">
                    治療類別
                    </th>
                    <th style="text-align: left; width: 10%; border-right: 0px solid black; border-left: 0px solid black; border-top: none; border-bottom: 5px double black;">
                    健保碼
                    </th>
                    <th style="text-align: left; width: 28%; border-right: 0px solid black; border-left: 0px solid black; border-top: none; border-bottom: 5px double black;">
                    醫令名稱
                    </th>
                    <th style="text-align: right; width: 8%; border-right: 0px solid black; border-left: 0px solid black; border-top: none; border-bottom: 5px double black;">
                    總耗量
                    </th>
                    <th style="text-align: right; width: 8%; border-right: 0px solid black; border-left: 0px solid black; border-top: none; border-bottom: 5px double black;">
                    量占比
                    </th>
                    <th style="text-align: right; width: 6%; border-right: 0px solid black; border-left: 0px solid black; border-top: none; border-bottom: 5px double black;">
                    人數
                    </th>
                    <th style="text-align: right; width: 8%; border-right: 0px solid black; border-left: 0px solid black; border-top: none; border-bottom: 5px double black;">
                    人數占比
                    </th>
                    <th style="text-align: right; width: 6%; border-right: 0px solid black; border-left: 0px solid black; border-top: none; border-bottom: 5px double black;">
                    健保單價
                    </th>
                    <th style="text-align: right; width: 10%; border-right: 0px solid black; border-left: 0px solid black; border-top: none; border-bottom: 5px double black;">
                    健保總價
                    </th>
                    <th style="text-align: right; width: 8%; border-right: 0px solid black; border-left: 0px solid black; border-top: none; border-bottom: 5px double black;">
                    價占比
                    </th>
                </tr>`;
  }

  createHTMLBlock(data: OrderConsumptionReportItem) {
    if (this.isDental) {
      return ''; // 牙科使用 insertDentalListData 處理，不使用此方法
    }

    var summaryStyle = data.IsSummary ? "border-top: 1px dotted #777;" : "border-top: none;";
    var summaryFontStyle = data.IsSummary ? "font-weight: bold" : "";
    var doctorNameColumn = data.IsSummary ? " " : (this.showDoctorNameColume ? data.DoctorName : data.ClinicName);
    var yearMonth = data.IsSummary ? "" : this.onGetDateString(data.UsageYear + '/' + data.UsageMonth + '/1', true, '', true);
    var showDrugCode = data.IsSummary ? '' : data.DrugCode;
    var showStdCode = data.IsSummary ? '' : data.StdCode;
    var showDrugName = data.IsSummary ? '小計' : data.DrugName;
    var showIprice = data.IsSummary ? '' : data.Iprice;
    // 查詢治療類別
    var treatmentCategory = '';
    if (!data.IsSummary && data.StdCode) {
      const categoryCode = this.dentalCategoryService.getCategoryCode(data.StdCode);
      if (categoryCode) {
        const description = this.dentalCategoryService.getCategoryDescription(categoryCode);
        treatmentCategory = categoryCode + (description ? '(' + description + ')' : '');
      }
    }
    this.totalSummary += (data.IsSummary ? data.NHIAmount : 0);
    // this.totalBoxSummary += (data.IsSummary ? data.TotalBox : 0);
    this.totalBoxSummary += (data.IsSummary ? data.TotalUsageAmount : 0);
    this.totalNHIAmount += (data.IsSummary ? data.NHIAmount : 0);
    var blankLine = data.IsSummary ? '<tr><td colspan="9" style="height: 30px; border-right: none; border-left: none; border-bottom: none; border-top: none;">　</td></tr>' : '';
    return '<tr>' +
      '<td style="text-align: left; font-weight: bold; ' + summaryStyle + ' border-bottom: none;">' + doctorNameColumn + '</td>' +
      '<td style="text-align: left; font-size: 10pt; ' + summaryStyle + ' border-bottom: none;">' + treatmentCategory + '</td>' +
      '<td style="text-align: left; ' + summaryStyle + ' border-bottom: none;">' + showDrugCode + '</td>' +
      '<td style="text-align: left; ' + summaryStyle + ' border-bottom: none;">' + showStdCode + '</td>' +
      '<td style="text-align: left; ' + summaryStyle + ' border-bottom: none;">' + yearMonth + '</td>' +
      '<td style="text-align: left; ' + summaryStyle + ' border-bottom: none; ' + summaryFontStyle + '">' + showDrugName + '</td>' +
      '<td style="text-align: right; ' + summaryStyle + ' border-bottom: none;">' + showIprice + '</td>' +
      '<td style="text-align: right; ' + summaryStyle + ' border-bottom: none;">' + data.TotalUsageAmount + '</td>' +
      '<td style="text-align: right; ' + summaryStyle + ' border-bottom: none; ">' + data.NHIAmount + '</td>' +
      '</tr>' + blankLine;
  }

  // 千分位格式化
  private formatNumberWithCommas(value: number | string): string {
    if (!value && value !== 0) return '';
    const num = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(num)) return '';
    return num.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  // 牙科專用：取得治療類別代碼和標題
  private getDentalCategoryInfo(stdCode: string): { code: string; title: string } {
    if (!stdCode) {
      return { code: '其他', title: '其他' };
    }
    const categoryCode = this.dentalCategoryService.getCategoryCode(stdCode);
    if (!categoryCode) {
      return { code: '其他', title: '其他' };
    }
    const description = this.dentalCategoryService.getCategoryDescription(categoryCode);
    return {
      code: categoryCode,
      title: description || categoryCode
    };
  }

  // 牙科專用：取得分類排序順序
  private getDentalCategoryOrder(categoryCode: string): number {
    if (categoryCode === '其他') {
      return 999;
    }
    return this.dentalCategoryService.getCategoryOrder(categoryCode);
  }

  // 牙科專用：根據 RxType 取得標籤
  private getRxTypeLabel(rxType: number): string {
    switch (rxType) {
      case 1:
        return '診察';
      case 2:
      case 3:
      case 4:
        return '處方';
      default:
        return '處置';
    }
  }

  // 牙科專用：根據 RxType 取得排序順序
  private getRxTypeOrder(rxType: number): number {
    switch (rxType) {
      case 1:
        return 1; // 診察
      case 2:
      case 3:
      case 4:
        return 2; // 處方
      default:
        return 3; // 處置
    }
  }

  // 牙科專用：計算該月總病患數
  private calculateMonthTotalPatients(yearMonth: string, monthlyPatientSet: Map<string, Set<number>>): number {
    if (!monthlyPatientSet || !monthlyPatientSet.has(yearMonth)) {
      return 0;
    }
    return monthlyPatientSet.get(yearMonth).size;
  }

  // 牙科專用：計算該RxType的患者數
  private calculateRxTypeTotalPatients(yearMonth: string, rxTypeLabel: string, rxTypePatientSet: Map<string, Set<number>>): number {
    const key = `${yearMonth}|${rxTypeLabel}`;
    if (!rxTypePatientSet || !rxTypePatientSet.has(key)) {
      return 0;
    }
    return rxTypePatientSet.get(key).size;
  }

  // 牙科專用：計算該類別病患數
  private calculateCategoryTotalPatients(items: any[]): number {
    return this.countCategoryPatients(items);
  }

  // 牙科專用：計算該醫師該月病患數
  private calculateDoctorTotalPatients(yearMonth: string, rxTypeLabel: string, doctorName: string, doctorPatientSet: Map<string, Set<number>>): number {
    const key = `${yearMonth}|${rxTypeLabel}|${doctorName}`;
    if (!doctorPatientSet || !doctorPatientSet.has(key)) {
      return 0;
    }
    return doctorPatientSet.get(key).size;
  }

  // 牙科專用：計算該醫師整個月份的病患數（醫師分組模式）
  private calculateDoctorlMonthTotalPatients(yearMonth: string, doctorName: string, doctorPatientSet: Map<string, Set<number>>): number {
    const key = `${yearMonth}|${doctorName}`;
    if (!doctorPatientSet || !doctorPatientSet.has(key)) {
      return 0;
    }
    return doctorPatientSet.get(key).size;
  }

  // 牙科專用：計算該醫師該RxType的病患數（醫師分組模式）
  private calculateDoctorRxTypeTotalPatients(yearMonth: string, doctorName: string, rxTypeLabel: string, doctorRxTypePatientSet: Map<string, Set<number>>): number {
    const key = `${yearMonth}|${doctorName}|${rxTypeLabel}`;
    if (!doctorRxTypePatientSet || !doctorRxTypePatientSet.has(key)) {
      return 0;
    }
    return doctorRxTypePatientSet.get(key).size;
  }

  // 牙科專用：計算項目列表的患者數（去重）
  private countPatients(items: any[]): number {
    const patientSet = new Set<number>();
    items.forEach(item => {
      if (item.PatientIds && Array.isArray(item.PatientIds)) {
        item.PatientIds.forEach(pid => patientSet.add(pid));
      } else if (item.PatientId) {
        patientSet.add(item.PatientId);
      }
    });
    return patientSet.size;
  }

  // 牙科專用：計算類別的患者數（去重）
  private countCategoryPatients(categoryItems: any[]): number {
    const patientSet = new Set<number>();
    categoryItems.forEach(item => {
      if (item.PatientIds && Array.isArray(item.PatientIds)) {
        item.PatientIds.forEach(pid => patientSet.add(pid));
      } else if (item.PatientId) {
        patientSet.add(item.PatientId);
      }
    });
    return patientSet.size;
  }

  // 牙科專用：組織資料以支持分組結構 + 計算患者數
  private organizeDentalData(): Map<string, Map<string, any>> {
    // 正確結構：Map<yearMonth, Map<rxTypeLabel, Map<doctorKey, items[]>>>
    // 醫師分組模式會用 DoctorName 作為 doctorKey
    // 診所分組模式會用空字符串 '' 作為 doctorKey
    const grouped = new Map<string, Map<string, any>>();
    // 計算每月的患者數：Map<yearMonth, Set<patientId>>
    const monthlyPatientSet = new Map<string, Set<number>>();
    // 計算每個月每個RxType的患者數：Map<yearMonth|rxTypeLabel, Set<patientId>>
    const rxTypePatientSet = new Map<string, Set<number>>();
    // 計算每個月每個RxType每個醫師的患者數：Map<yearMonth|rxTypeLabel|doctorKey, Set<patientId>>
    const doctorPatientSet = new Map<string, Set<number>>();

    // 先組織資料
    this.listItems.forEach(item => {
      if (item.IsSummary) return;

      const yearMonth = this.onGetDateString(item.UsageYear + '/' + item.UsageMonth + '/1', true, '', true);
      const rxTypeLabel = this.getRxTypeLabel(item.RxType);
      const doctorKey = this.showDoctorNameColume ? (item.DoctorName || '') : '';
      const stdKey = `${item.DoctorName || ''}|${item.StdCode || ''}|${item.DrugName || ''}|${item.Iprice || ''}|${item.TotalUsageAmount || ''}|${item.NHIAmount || ''}`;

      // 記錄患者ID用於統計（月級別）
      if (!monthlyPatientSet.has(yearMonth)) {
        monthlyPatientSet.set(yearMonth, new Set());
      }
      if (item.PatientIds && Array.isArray(item.PatientIds)) {
        item.PatientIds.forEach(pid => monthlyPatientSet.get(yearMonth).add(pid));
      } else if (item.PatientId) {
        monthlyPatientSet.get(yearMonth).add(item.PatientId);
      }

      // 根據分組模式組織資料
      if (this.showDoctorNameColume) {
        // 醫師分組模式：Year-Month → RxType → Doctor → Items
        if (!grouped.has(yearMonth)) {
          grouped.set(yearMonth, new Map());
        }
        const rxTypeMap = grouped.get(yearMonth);

        if (!rxTypeMap.has(rxTypeLabel)) {
          rxTypeMap.set(rxTypeLabel, new Map());
        }
        const doctorMap = rxTypeMap.get(rxTypeLabel);

        if (!doctorMap.has(doctorKey)) {
          doctorMap.set(doctorKey, []);
        }

        // 記錄患者ID用於統計（RxType級別）
        const rxTypePatientKey = `${yearMonth}|${rxTypeLabel}`;
        if (!rxTypePatientSet.has(rxTypePatientKey)) {
          rxTypePatientSet.set(rxTypePatientKey, new Set());
        }
        if (item.PatientIds && Array.isArray(item.PatientIds)) {
          item.PatientIds.forEach(pid => rxTypePatientSet.get(rxTypePatientKey).add(pid));
        } else if (item.PatientId) {
          rxTypePatientSet.get(rxTypePatientKey).add(item.PatientId);
        }

        // 記錄患者ID用於統計（RxType+Doctor級別）
        const doctorPatientKey = `${yearMonth}|${rxTypeLabel}|${doctorKey}`;
        if (!doctorPatientSet.has(doctorPatientKey)) {
          doctorPatientSet.set(doctorPatientKey, new Set());
        }
        if (item.PatientIds && Array.isArray(item.PatientIds)) {
          item.PatientIds.forEach(pid => doctorPatientSet.get(doctorPatientKey).add(pid));
        } else if (item.PatientId) {
          doctorPatientSet.get(doctorPatientKey).add(item.PatientId);
        }

        const doctorItems = doctorMap.get(doctorKey);
        const existingItem = doctorItems.find(i => i.__stdKey === stdKey);
        if (!existingItem) {
          doctorItems.push({
            ...item,
            __stdKey: stdKey,
            categoryInfo: this.getDentalCategoryInfo(item.StdCode),
            categoryOrder: this.getDentalCategoryOrder(this.getDentalCategoryInfo(item.StdCode).code)
          });
        }
      } else {
        // 診所分組模式：Year-Month → RxType → Items
        if (!grouped.has(yearMonth)) {
          grouped.set(yearMonth, new Map());
        }
        const rxTypeMap = grouped.get(yearMonth);

        if (!rxTypeMap.has(rxTypeLabel)) {
          rxTypeMap.set(rxTypeLabel, new Map());
        }
        const clinicMap = rxTypeMap.get(rxTypeLabel);

        const clinicKey = '';  // 診所模式下統一使用空字符串
        if (!clinicMap.has(clinicKey)) {
          clinicMap.set(clinicKey, []);
        }

        // 記錄患者ID用於統計（RxType級別）
        const rxTypePatientKey = `${yearMonth}|${rxTypeLabel}`;
        if (!rxTypePatientSet.has(rxTypePatientKey)) {
          rxTypePatientSet.set(rxTypePatientKey, new Set());
        }
        if (item.PatientIds && Array.isArray(item.PatientIds)) {
          item.PatientIds.forEach(pid => rxTypePatientSet.get(rxTypePatientKey).add(pid));
        } else if (item.PatientId) {
          rxTypePatientSet.get(rxTypePatientKey).add(item.PatientId);
        }

        const clinicItems = clinicMap.get(clinicKey);
        const existingItem = clinicItems.find(i => i.__stdKey === stdKey);
        if (!existingItem) {
          clinicItems.push({
            ...item,
            __stdKey: stdKey,
            categoryInfo: this.getDentalCategoryInfo(item.StdCode),
            categoryOrder: this.getDentalCategoryOrder(this.getDentalCategoryInfo(item.StdCode).code)
          });
        }
      }
    });

    // 將患者統計附加到grouped中，以便後續使用
    (grouped as any).__monthlyPatientSet = monthlyPatientSet;
    (grouped as any).__doctorPatientSet = doctorPatientSet;
    (grouped as any).__rxTypePatientSet = rxTypePatientSet;

    return grouped;
  }

  // 牙科專用：插入列表資料
  insertDentalListData() {
    var html_Block = "";
    this.totalSummary = 0;
    this.totalBoxSummary = 0;
    this.totalNHIAmount = 0;
    var iPage = 0;
    var iBlock = 0;
    this.elContainer.innerHTML = this.createHTMLPage(iPage);
    var html_header = this.createHTMLPageHeader(iPage);
    var html_ListerHeader = this.createDentalHTMLListHeader();
    var html_finish = this.createHTMLFinish();
    var elPageContent = document.getElementById("page-" + iPage + "-content");

    elPageContent.innerHTML = html_header;
    var elTableContent = document.getElementById("table-" + iPage + "-content");
    elTableContent.innerHTML = html_ListerHeader;

    const groupedData = this.organizeDentalData();
    const sortedMonths = Array.from(groupedData.keys()).sort();

    // 獲取患者統計數據
    const monthlyPatientSet = (groupedData as any).__monthlyPatientSet as Map<string, Set<number>>;
    const doctorPatientSet = (groupedData as any).__doctorPatientSet as Map<string, Set<number>>;
    const rxTypePatientSet = (groupedData as any).__rxTypePatientSet as Map<string, Set<number>>;

    // 統一的結構：Year-Month → RxType → Doctor/Clinic → Items
    sortedMonths.forEach((yearMonth, monthIndex) => {
      const rxTypeMap = groupedData.get(yearMonth) || new Map<string, Map<string, any[]>>();
      const monthTotalPatients = this.calculateMonthTotalPatients(yearMonth, monthlyPatientSet);

      // 計算此年月的總量和總額
      let monthTotalUsage = 0;
      let monthTotalAmount = 0;
      rxTypeMap.forEach(doctorMap => {
        doctorMap.forEach(items => {
          items.forEach(item => {
            monthTotalUsage += Number(item.TotalUsageAmount) || 0;
            monthTotalAmount += Number(item.NHIAmount) || 0;
          });
        });
      });
      this.totalBoxSummary += monthTotalUsage;
      this.totalNHIAmount += monthTotalAmount;

      // 年月大標題
      html_Block = `<tr><td colspan="10" style="background-color: #e6f2ff; font-weight: bold; border-top: 3px solid #777; border-bottom: 1px solid black; padding: 5px;">申報年月：${yearMonth}</td></tr>`;
      var prevTableContent = elTableContent.innerHTML;
      elTableContent.innerHTML += html_Block;

      if (elPageContent.offsetHeight > this.heightPageWithoutPadding) {
        elTableContent.innerHTML = prevTableContent;
        iPage += 1;
        this.elContainer.innerHTML += this.createHTMLPage(iPage);
        elPageContent = document.getElementById("page-" + iPage + "-content");
        elPageContent.innerHTML += this.createHTMLPageHeader(iPage);
        elTableContent = document.getElementById("table-" + iPage + "-content");
        elTableContent.innerHTML = html_ListerHeader + html_Block;
        this.pageContent[iPage] = [];
        this.pageContent[iPage].push(iBlock);
      } else {
        this.pageContent[iPage].push(iBlock);
      }
      iBlock += 1;

      // 按 RxType 排序
      const sortedRxTypes = Array.from(rxTypeMap.keys()).sort((a, b) =>
        this.getRxTypeOrder((a as string) === '診察' ? 1 : (a as string) === '處方' ? 2 : 99) -
        this.getRxTypeOrder((b as string) === '診察' ? 1 : (b as string) === '處方' ? 2 : 99)
      ) as string[];

      sortedRxTypes.forEach((rxTypeLabel, rxTypeIndex) => {
        const doctorMap = rxTypeMap.get(rxTypeLabel) || new Map<string, any[]>();
        const doctors = Array.from(doctorMap.keys()) as string[];
        const rxTypeTotalPatients = this.calculateRxTypeTotalPatients(yearMonth, rxTypeLabel, rxTypePatientSet);

        // 計算此 RxType 的總量和總額
        let rxTypeTotalUsage = 0;
        let rxTypeTotalAmount = 0;
        doctorMap.forEach(items => {
          items.forEach(item => {
            rxTypeTotalUsage += Number(item.TotalUsageAmount) || 0;
            rxTypeTotalAmount += Number(item.NHIAmount) || 0;
          });
        });

        // RxType 小標題
        html_Block = `<tr><td colspan="10" style="background-color: #e9fae8; font-weight: bold; border-top: 1px solid #999; border-bottom: 1px solid #999; padding: 3px;">${rxTypeLabel}</td></tr>`;
        prevTableContent = elTableContent.innerHTML;
        elTableContent.innerHTML += html_Block;

        if (elPageContent.offsetHeight > this.heightPageWithoutPadding) {
          elTableContent.innerHTML = prevTableContent;
          iPage += 1;
          this.elContainer.innerHTML += this.createHTMLPage(iPage);
          elPageContent = document.getElementById("page-" + iPage + "-content");
          elPageContent.innerHTML += this.createHTMLPageHeader(iPage);
          elTableContent = document.getElementById("table-" + iPage + "-content");
          elTableContent.innerHTML = html_ListerHeader + html_Block;
          this.pageContent[iPage] = [];
          this.pageContent[iPage].push(iBlock);
        } else {
          this.pageContent[iPage].push(iBlock);
        }
        iBlock += 1;

        doctors.forEach((doctorName, doctorIndex) => {
          const items = doctorMap.get(doctorName) || [];
          const doctorTotalPatients = this.calculateDoctorTotalPatients(yearMonth, rxTypeLabel, doctorName, doctorPatientSet);

          let doctorTotalUsage = 0;
          let doctorTotalAmount = 0;
          items.forEach(item => {
            doctorTotalUsage += Number(item.TotalUsageAmount) || 0;
            doctorTotalAmount += Number(item.NHIAmount) || 0;
          });

          // 醫師小標題（僅在醫師分組模式，且 doctorName 非空）
          if (this.showDoctorNameColume && doctorName) {
            html_Block = `<tr><td colspan="10" style="background-color: #f3f3f3; font-weight: bold; border-top: 1px solid #999; border-bottom: 1px solid #999; padding: 3px;">醫師：${doctorName}</td></tr>`;
            prevTableContent = elTableContent.innerHTML;
            elTableContent.innerHTML += html_Block;

            if (elPageContent.offsetHeight > this.heightPageWithoutPadding) {
              elTableContent.innerHTML = prevTableContent;
              iPage += 1;
              this.elContainer.innerHTML += this.createHTMLPage(iPage);
              elPageContent = document.getElementById("page-" + iPage + "-content");
              elPageContent.innerHTML += this.createHTMLPageHeader(iPage);
              elTableContent = document.getElementById("table-" + iPage + "-content");
              elTableContent.innerHTML = html_ListerHeader + html_Block;
              this.pageContent[iPage] = [];
              this.pageContent[iPage].push(iBlock);
            } else {
              this.pageContent[iPage].push(iBlock);
            }
            iBlock += 1;
          }

          // 按類別排序
          items.sort((a, b) => {
            if (a.categoryOrder !== b.categoryOrder) {
              return a.categoryOrder - b.categoryOrder;
            }
            return (a.categoryInfo.code).localeCompare(b.categoryInfo.code);
          });

          // 按類別分組並小計
          let currentCategory = '';
          let categoryItems: any[] = [];
          let categoryTotalUsage = 0;
          let categoryTotalAmount = 0;

          const flushCategory = () => {
            if (categoryItems.length > 0) {
              const categoryTotalPatients = this.calculateCategoryTotalPatients(categoryItems);

              categoryItems.forEach(item => {
                const itemPatientCount = this.countPatients([item]);
                html_Block = this.createDentalItemRow(item, monthTotalUsage, monthTotalAmount, monthTotalPatients, false, itemPatientCount, rxTypeLabel);
                prevTableContent = elTableContent.innerHTML;
                elTableContent.innerHTML += html_Block;

                if (elPageContent.offsetHeight > this.heightPageWithoutPadding) {
                  elTableContent.innerHTML = prevTableContent;
                  iPage += 1;
                  this.elContainer.innerHTML += this.createHTMLPage(iPage);
                  elPageContent = document.getElementById("page-" + iPage + "-content");
                  elPageContent.innerHTML += this.createHTMLPageHeader(iPage);
                  elTableContent = document.getElementById("table-" + iPage + "-content");
                  elTableContent.innerHTML = html_ListerHeader + html_Block;
                  this.pageContent[iPage] = [];
                  this.pageContent[iPage].push(iBlock);
                } else {
                  this.pageContent[iPage].push(iBlock);
                }
                iBlock += 1;
              });

              // 類別小計
              html_Block = this.createDentalCategorySubtotal(currentCategory, categoryTotalUsage, categoryTotalAmount, monthTotalUsage, monthTotalAmount, categoryTotalPatients, monthTotalPatients, rxTypeLabel);
              // 只有當 html_Block 不為空時才進行渲染（診察/處方的類別小計會被隱藏）
              if (html_Block) {
                prevTableContent = elTableContent.innerHTML;
                elTableContent.innerHTML += html_Block;

                if (elPageContent.offsetHeight > this.heightPageWithoutPadding) {
                  elTableContent.innerHTML = prevTableContent;
                  iPage += 1;
                  this.elContainer.innerHTML += this.createHTMLPage(iPage);
                  elPageContent = document.getElementById("page-" + iPage + "-content");
                  elPageContent.innerHTML += this.createHTMLPageHeader(iPage);
                  elTableContent = document.getElementById("table-" + iPage + "-content");
                  elTableContent.innerHTML = html_ListerHeader + html_Block;
                  this.pageContent[iPage] = [];
                  this.pageContent[iPage].push(iBlock);
                } else {
                  this.pageContent[iPage].push(iBlock);
                }
                iBlock += 1;
              }
            }
          };

          items.forEach(item => {
            const itemCategory = item.categoryInfo.code;
            if (currentCategory !== itemCategory && currentCategory !== '') {
              flushCategory();
              categoryItems = [];
              categoryTotalUsage = 0;
              categoryTotalAmount = 0;
            }
            currentCategory = itemCategory;
            categoryItems.push(item);
            categoryTotalUsage += Number(item.TotalUsageAmount) || 0;
            categoryTotalAmount += Number(item.NHIAmount) || 0;
          });

          // 最後一組類別
          flushCategory();

          // 醫師小計（僅在醫師分組模式）
          if (this.showDoctorNameColume && doctorName) {
            html_Block = this.createDentalDoctorSubtotal(doctorName, doctorTotalUsage, doctorTotalAmount, rxTypeTotalUsage, rxTypeTotalAmount, doctorTotalPatients, rxTypeTotalPatients);
            prevTableContent = elTableContent.innerHTML;
            elTableContent.innerHTML += html_Block;

            if (elPageContent.offsetHeight > this.heightPageWithoutPadding) {
              elTableContent.innerHTML = prevTableContent;
              iPage += 1;
              this.elContainer.innerHTML += this.createHTMLPage(iPage);
              elPageContent = document.getElementById("page-" + iPage + "-content");
              elPageContent.innerHTML += this.createHTMLPageHeader(iPage);
              elTableContent = document.getElementById("table-" + iPage + "-content");
              elTableContent.innerHTML = html_ListerHeader + html_Block;
              this.pageContent[iPage] = [];
              this.pageContent[iPage].push(iBlock);
            } else {
              this.pageContent[iPage].push(iBlock);
            }
            iBlock += 1;

            if (doctorIndex < doctors.length - 1) {
              html_Block = this.createDentalSpacerRow();
              prevTableContent = elTableContent.innerHTML;
              elTableContent.innerHTML += html_Block;

              if (elPageContent.offsetHeight > this.heightPageWithoutPadding) {
                elTableContent.innerHTML = prevTableContent;
                iPage += 1;
                this.elContainer.innerHTML += this.createHTMLPage(iPage);
                elPageContent = document.getElementById("page-" + iPage + "-content");
                elPageContent.innerHTML += this.createHTMLPageHeader(iPage);
                elTableContent = document.getElementById("table-" + iPage + "-content");
                elTableContent.innerHTML = html_ListerHeader + html_Block;
                this.pageContent[iPage] = [];
                this.pageContent[iPage].push(iBlock);
              } else {
                this.pageContent[iPage].push(iBlock);
              }
              iBlock += 1;
            }
          }
        });

        // RxType 總計
        html_Block = this.createDentalRxTypeSubtotal(rxTypeLabel, rxTypeTotalUsage, rxTypeTotalAmount, monthTotalUsage, monthTotalAmount, rxTypeTotalPatients, monthTotalPatients);
        prevTableContent = elTableContent.innerHTML;
        elTableContent.innerHTML += html_Block;

        if (elPageContent.offsetHeight > this.heightPageWithoutPadding) {
          elTableContent.innerHTML = prevTableContent;
          iPage += 1;
          this.elContainer.innerHTML += this.createHTMLPage(iPage);
          elPageContent = document.getElementById("page-" + iPage + "-content");
          elPageContent.innerHTML += this.createHTMLPageHeader(iPage);
          elTableContent = document.getElementById("table-" + iPage + "-content");
          elTableContent.innerHTML = html_ListerHeader + html_Block;
          this.pageContent[iPage] = [];
          this.pageContent[iPage].push(iBlock);
        } else {
          this.pageContent[iPage].push(iBlock);
        }
        iBlock += 1;

        if (rxTypeIndex < sortedRxTypes.length - 1) {
          html_Block = this.createDentalSpacerRow();
          prevTableContent = elTableContent.innerHTML;
          elTableContent.innerHTML += html_Block;

          if (elPageContent.offsetHeight > this.heightPageWithoutPadding) {
            elTableContent.innerHTML = prevTableContent;
            iPage += 1;
            this.elContainer.innerHTML += this.createHTMLPage(iPage);
            elPageContent = document.getElementById("page-" + iPage + "-content");
            elPageContent.innerHTML += this.createHTMLPageHeader(iPage);
            elTableContent = document.getElementById("table-" + iPage + "-content");
            elTableContent.innerHTML = html_ListerHeader + html_Block;
            this.pageContent[iPage] = [];
            this.pageContent[iPage].push(iBlock);
          } else {
            this.pageContent[iPage].push(iBlock);
          }
          iBlock += 1;
        }
      });

      // 申報年月總計
      html_Block = this.createDentalMonthTotal(yearMonth, monthTotalUsage, monthTotalAmount, monthTotalPatients);
      prevTableContent = elTableContent.innerHTML;
      elTableContent.innerHTML += html_Block;

      if (elPageContent.offsetHeight > this.heightPageWithoutPadding) {
        elTableContent.innerHTML = prevTableContent;
        iPage += 1;
        this.elContainer.innerHTML += this.createHTMLPage(iPage);
        elPageContent = document.getElementById("page-" + iPage + "-content");
        elPageContent.innerHTML += this.createHTMLPageHeader(iPage);
        elTableContent = document.getElementById("table-" + iPage + "-content");
        elTableContent.innerHTML = html_ListerHeader + html_Block;
        this.pageContent[iPage] = [];
        this.pageContent[iPage].push(iBlock);
      } else {
        this.pageContent[iPage].push(iBlock);
      }
      iBlock += 1;

      if (monthIndex < sortedMonths.length - 1) {
        html_Block = this.createDentalSpacerRow();
        prevTableContent = elTableContent.innerHTML;
        elTableContent.innerHTML += html_Block;

        if (elPageContent.offsetHeight > this.heightPageWithoutPadding) {
          elTableContent.innerHTML = prevTableContent;
          iPage += 1;
          this.elContainer.innerHTML += this.createHTMLPage(iPage);
          elPageContent = document.getElementById("page-" + iPage + "-content");
          elPageContent.innerHTML += this.createHTMLPageHeader(iPage);
          elTableContent = document.getElementById("table-" + iPage + "-content");
          elTableContent.innerHTML = html_ListerHeader + html_Block;
          this.pageContent[iPage] = [];
          this.pageContent[iPage].push(iBlock);
        } else {
          this.pageContent[iPage].push(iBlock);
        }
        iBlock += 1;
      }
    });

    elPageContent.innerHTML += html_finish;
    this.upperboundIndex = iPage;
    for (var i = 0; i <= iPage; i++) {
      var tPage = document.getElementById("totalPage-" + i);
      tPage.innerHTML = "" + (this.upperboundIndex + 1);
    }
  }

  // 牙科專用：建立單一項目列
  private createDentalItemRow(item: any, monthTotalUsage: number, monthTotalAmount: number, monthTotalPatients: number, isSummary: boolean, itemPatientCount: number = 0, rxTypeLabel: string = ''): string {
    const categoryTitle = item.categoryInfo.title;
    const stdCode = item.StdCode || '';
    const drugName = item.DrugName || '';
    const usage = Number(item.TotalUsageAmount) || 0;
    const usageRatio = monthTotalUsage > 0 ? ((usage / monthTotalUsage) * 100).toFixed(2) : '0.00';
    const iprice = item.Iprice || '';
    const ipriceFormatted = this.formatNumberWithCommas(iprice);
    const amount = Number(item.NHIAmount) || 0;
    const amountFormatted = this.formatNumberWithCommas(amount);
    const amountRatio = monthTotalAmount > 0 ? ((amount / monthTotalAmount) * 100).toFixed(2) : '0.00';

    // 患者數計算
    const patientCount = itemPatientCount || 0;
    const patientRatio = monthTotalPatients > 0 ? ((patientCount / monthTotalPatients) * 100).toFixed(2) : '0.00';

    const summaryStyle = isSummary ? "border-top: 1px dotted #777;" : "border-top: none;";

    // 治療類別：如果是「診察」或「處方」，直接顯示該標籤；否則顯示原來的分類代碼
    let treatmentCategory = item.categoryInfo.code;
    let treatmentCategoryTitle = categoryTitle;
    if (rxTypeLabel === '診察' || rxTypeLabel === '處方') {
      treatmentCategory = rxTypeLabel;
      treatmentCategoryTitle = rxTypeLabel;
    }

    return '<tr>' +
      '<td style="text-align: left; ' + summaryStyle + ' border-bottom: none;" title="' + treatmentCategoryTitle + '">' + treatmentCategory + '</td>' +
      '<td style="text-align: left; ' + summaryStyle + ' border-bottom: none;">' + stdCode + '</td>' +
      '<td style="text-align: left; ' + summaryStyle + ' border-bottom: none;">' + drugName + '</td>' +
      '<td style="text-align: right; ' + summaryStyle + ' border-bottom: none;">' + usage + '</td>' +
      '<td style="text-align: right; ' + summaryStyle + ' border-bottom: none;">' + usageRatio + '%</td>' +
      '<td style="text-align: right; ' + summaryStyle + ' border-bottom: none;">' + patientCount + '</td>' +
      '<td style="text-align: right; ' + summaryStyle + ' border-bottom: none;">' + patientRatio + '%</td>' +
      '<td style="text-align: right; ' + summaryStyle + ' border-bottom: none;">' + ipriceFormatted + '</td>' +
      '<td style="text-align: right; ' + summaryStyle + ' border-bottom: none;">' + amountFormatted + '</td>' +
      '<td style="text-align: right; ' + summaryStyle + ' border-bottom: none;">' + amountRatio + '%</td>' +
      '</tr>';
  }

  // 牙科專用：建立類別小計列
  private createDentalCategorySubtotal(categoryCode: string, totalUsage: number, totalAmount: number, monthTotalUsage: number, monthTotalAmount: number, totalPatients: number = 0, monthTotalPatients: number = 0, rxTypeLabel: string = ''): string {
    // 如果是「診察」或「處方」，隱藏類別小計（保留代碼以防未來需要）
    if (rxTypeLabel === '診察' || rxTypeLabel === '處方') {
      return '';
    }

    const usageRatio = monthTotalUsage > 0 ? ((totalUsage / monthTotalUsage) * 100).toFixed(2) : '0.00';
    const totalAmountFormatted = this.formatNumberWithCommas(totalAmount);
    const amountRatio = monthTotalAmount > 0 ? ((totalAmount / monthTotalAmount) * 100).toFixed(2) : '0.00';

    // 患者數計算
    const patientRatio = monthTotalPatients > 0 ? ((totalPatients / monthTotalPatients) * 100).toFixed(2) : '0.00';

    const subtotalLabel = categoryCode === '其他' ? '其他小計' : categoryCode + '小計';

    return '<tr style="background-color: #f9f9f9; border-top: 1px dotted #777; border-bottom: 1px solid #777;">' +
      '<td colspan="3" style="text-align: right; font-weight: bold; border-bottom: none;">' + subtotalLabel + '</td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + totalUsage + '</td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + usageRatio + '%</td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + totalPatients + '</td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + patientRatio + '%</td>' +
      '<td style="text-align: right; border-bottom: none;"></td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + totalAmountFormatted + '</td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + amountRatio + '%</td>' +
      '</tr>';
  }

  // 牙科專用：建立醫師小計列
  private createDentalDoctorSubtotal(doctorName: string, totalUsage: number, totalAmount: number, monthTotalUsage: number, monthTotalAmount: number, totalPatients: number = 0, monthTotalPatients: number = 0): string {
    const usageRatio = monthTotalUsage > 0 ? ((totalUsage / monthTotalUsage) * 100).toFixed(2) : '0.00';
    const totalAmountFormatted = this.formatNumberWithCommas(totalAmount);
    const amountRatio = monthTotalAmount > 0 ? ((totalAmount / monthTotalAmount) * 100).toFixed(2) : '0.00';

    // 患者數計算
    const patientRatio = monthTotalPatients > 0 ? ((totalPatients / monthTotalPatients) * 100).toFixed(2) : '0.00';

    return '<tr style="background-color: #f3f3f3; border-top: 1px solid #777; border-bottom: 3px solid #777;">' +
      '<td colspan="3" style="text-align: right; font-weight: bold; border-bottom: none;">' + doctorName + '醫師小計</td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + totalUsage + '</td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + usageRatio + '%</td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + totalPatients + '</td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + patientRatio + '%</td>' +
      '<td style="text-align: right; border-bottom: none;"></td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + totalAmountFormatted + '</td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + amountRatio + '%</td>' +
      '</tr>';
  }

  // 牙科專用：建立RxType總計列（診察/處方/處置）
  private createDentalRxTypeSubtotal(rxTypeLabel: string, totalUsage: number, totalAmount: number, monthTotalUsage: number, monthTotalAmount: number, totalPatients: number = 0, monthTotalPatients: number = 0): string {
    const usageRatio = monthTotalUsage > 0 ? ((totalUsage / monthTotalUsage) * 100).toFixed(2) : '0.00';
    const totalAmountFormatted = this.formatNumberWithCommas(totalAmount);
    const amountRatio = monthTotalAmount > 0 ? ((totalAmount / monthTotalAmount) * 100).toFixed(2) : '0.00';

    // 患者數計算
    const patientRatio = monthTotalPatients > 0 ? ((totalPatients / monthTotalPatients) * 100).toFixed(2) : '0.00';

    return '<tr style="background-color: #e9fae8; border-top: 1px dotted #777; border-bottom: 2px solid #777;">' +
      '<td colspan="3" style="text-align: right; font-weight: bold; border-bottom: none;">' + rxTypeLabel + '總計</td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + totalUsage + '</td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + usageRatio + '%</td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + totalPatients + '</td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + patientRatio + '%</td>' +
      '<td style="text-align: right; border-bottom: none;"></td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + totalAmountFormatted + '</td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + amountRatio + '%</td>' +
      '</tr>';
  }

  // 牙科專用：建立醫師月份小計列（醫師分組模式）
  private createDentalDoctorMonthSubtotal(doctorName: string, totalUsage: number, totalAmount: number, monthTotalUsage: number, monthTotalAmount: number, totalPatients: number = 0, monthTotalPatients: number = 0): string {
    const usageRatio = monthTotalUsage > 0 ? ((totalUsage / monthTotalUsage) * 100).toFixed(2) : '0.00';
    const totalAmountFormatted = this.formatNumberWithCommas(totalAmount);
    const amountRatio = monthTotalAmount > 0 ? ((totalAmount / monthTotalAmount) * 100).toFixed(2) : '0.00';

    // 患者數計算
    const patientRatio = monthTotalPatients > 0 ? ((totalPatients / monthTotalPatients) * 100).toFixed(2) : '0.00';

    return '<tr style="background-color: #f3f3f3; border-top: 1px solid #777; border-bottom: 3px solid #777;">' +
      '<td colspan="3" style="text-align: right; font-weight: bold; border-bottom: none;">' + doctorName + '醫師月計</td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + totalUsage + '</td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + usageRatio + '%</td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + totalPatients + '</td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + patientRatio + '%</td>' +
      '<td style="text-align: right; border-bottom: none;"></td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + totalAmountFormatted + '</td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + amountRatio + '%</td>' +
      '</tr>';
  }

  // 牙科專用：建立申報年月總計列
  private createDentalMonthTotal(yearMonth: string, totalUsage: number, totalAmount: number, totalPatients: number = 0): string {
    const totalAmountFormatted = this.formatNumberWithCommas(totalAmount);

    return '<tr style="background-color: #e6f2ff; border-top: 2px solid #555; border-bottom: 5px double black;">' +
      '<td colspan="3" style="text-align: right; font-weight: bold; border-bottom: none;">' + yearMonth + '年月總計</td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + totalUsage + '</td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">100.00%</td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + totalPatients + '</td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">100.00%</td>' +
      '<td style="text-align: right; border-bottom: none;"></td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">' + totalAmountFormatted + '</td>' +
      '<td style="text-align: right; font-weight: bold; border-bottom: none;">100.00%</td>' +
      '</tr>';
  }

  private createDentalSpacerRow(): string {
    return '<tr><td colspan="8" style="height: 18px; border-bottom: none; border-top: none;">　</td></tr>';
  }

  createHtmlTotalSummary() {
    return '<tr>' +
      '<td style="text-align: left; font-weight: bold; border-top: 1px dotted #777; border-bottom: none;">　</td>' +
      '<td style="text-align: left; border-top: 1px dotted #777; border-bottom: none;">　</td>' +
      '<td style="text-align: left; border-top: 1px dotted #777; border-bottom: none;">　</td>' +
      '<td style="text-align: left; border-top: 1px dotted #777; border-bottom: none;">　</td>' +
      '<td style="text-align: left; border-top: 1px dotted #777; border-bottom: none;">　</td>' +
      '<td style="text-align: left; border-top: 1px dotted #777; border-bottom: none; font-weight: bold">總計</td>' +
      '<td style="text-align: left; border-top: 1px dotted #777; border-bottom: none;">　</td>' +
      '<td style="text-align: right; border-top: 1px dotted #777; border-bottom: none;">' + this.totalBoxSummary + '</td>' +
      '<td style="text-align: right; border-top: 1px dotted #777; border-bottom: none; ">' + this.formatFloat(this.totalNHIAmount, 2) + '</td>' +
      '</tr>' +
      '<tr><td colspan="9" style="height: 30px; border-right: none; border-left: none; border-bottom: none; border-top: none;">　</td></tr>';
  }

  createHTMLPageHeader(iPage) {
    return `<div id="header" style="margin: 0px 10px;">
                    <div style="display: flex;column-gap: 5px;">
                        <table style="width: 100%; text-align: center; border: none;">
                            <tr>
                                <td colspan="8" style="height: 30px; text-align: center; font-weight: bolder; font-size: 16pt; border-right: none; border-left: none; border-bottom: none; border-top: none;">
                                    醫令用量統計報表
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2" style="width: 33%; font-size: 14px; text-align: left; padding-top: 5px; border-right: none; border-left: none; border-bottom: none; border-top: none;">
                                印表日期 ` + this.nowStr + `
                                </td>
                                <td colspan="3" style="width: 34%; font-size: 14px; text-align: center; border-right: none; border-left: none; border-bottom: none; border-top: none;">
                                期間：` + DateHelper.formatROCDate(this._sDate) + ` 至 ` + DateHelper.formatROCDate(this._eDate) + `
                                </td>
                                <td colspan="2" style="width: 33%; font-size: 14px; text-align: right; border-right: none; border-left: none; border-bottom: none; border-top: none;">
                                總筆數 ` + this.totalRecord + `
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2" style="font-size: 14px; text-align: left; padding-top: 5px; border-right: none; border-left: none; border-bottom: none; border-top: none;">
                                印表時間 ` + this.timeStr + `
                                </td>
                                <td colspan="3" style="font-size: 14px; text-align: center; border-right: none; border-left: none; border-bottom: none; border-top: none;">
                                </td>
                                <td colspan="2" style="font-size: 14px; text-align: right; border-right: none; border-left: none; border-bottom: none; border-top: none;">
                                ` + (iPage > 99 ? '' : ('頁' + (iPage + 1) + '/<span id="totalPage-' + iPage + '"></span>')) + `
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div style="-webkit-text-size-adjust: none; font-size: 12pt;zoom: 0.8;margin: 0px 10px; text-align: center;">
                    <label style="font-weight: bold; height: 23px;">　</label>
                </div>
                <div style="-webkit-text-size-adjust: none; font-size: 12px;zoom: 0.8;margin: 0px 10px;">
                    <div style="display: flex;column-gap: 5px;">
                        <table id="table-` + iPage + `-content" style="width: 100%; font-size: 12pt; text-align: center; border: none;">
                        </table>
                    </div>
                </div>`;
  }

  createHTMLPageHeader2(iPage) {
    return `<div style="-webkit-text-size-adjust: none; font-size: 12px;zoom: 0.8;margin: 0px 10px;">
                    <div style="display: flex;column-gap: 5px;">
                        <table id="table-` + iPage + `-content" style="width: 100%; font-size: 12pt; text-align: center; border: none;">
                        </table>
                    </div>
                </div>`;
  }

  createHTMLFinish() {
    return `<div style="-webkit-text-size-adjust: none; font-size: 12pt;zoom: 0.8;margin: 0px 10px; text-align: center; border-top: 5px double black;">
                    <label style="font-weight: bold;">以下空白</label>
                </div>`;
  }

  getHtml() {
    var html = this.reportContainer.nativeElement.innerHTML;
    for (var i = 0; i <= this.upperboundIndex; i++) {
      html = html.replace('box-shadow: 0 0 0.15cm rgba(0, 0, 0, 0.15);', '');
    }
    return html;
  }


  exportListData() {
    var html_Block = "";
    this.totalSummary = 0;
    this.totalBoxSummary = 0;
    this.totalNHIAmount = 0;
    var sPage = 100;
    var iPage = 100;
    var iBlock = 0;
    this.exportContainer.innerHTML = this.createHTMLPage(iPage);    // 整份報表的html內容
    var html_header = this.createHTMLPageHeader(iPage);     // 頁表頭
    var html_ListerHeader = this.createHTMLListHeader();    // List欄位顯示名稱
    var html_finish = this.createHTMLFinish();              // 報表結束 -- 以下空白
    var elPageContent = document.getElementById("page-" + iPage + "-content");  // 取得某頁的content，每次查詢後會取第0頁
    // 組報表內容
    // [頁表頭][List欄位顯示名稱]
    elPageContent.innerHTML = html_header;
    var elTableContent = document.getElementById("table-" + iPage + "-content");
    elTableContent.innerHTML = html_ListerHeader;
    for (let i = 0; i < this.listItems.length; i++) {
      // 加入 List 每一筆的內容
      html_Block = this.createHTMLBlock(this.listItems[i]);
      elTableContent.innerHTML += html_Block;
      this.pageContent2[iPage - sPage].push(iBlock);

      iBlock += 1;

      if (i == this.listItems.length - 1) {
        // 最後一筆=>加上總計
        var html_Total = this.createHtmlTotalSummary();
        elTableContent.innerHTML += html_Total;
        this.pageContent2[iPage - sPage].push(iBlock);
      }
    }
    elPageContent.innerHTML += html_finish;
    // this.upperboundIndex = iPage;
    // for (var i = 0; i <= iPage; i++) {
    //     var tPage = document.getElementById("totalPage-" + i);
    //     tPage.innerHTML = "" + (this.upperboundIndex + 1);
    // }
  }

  async onPrint() {
    if (this.listItems.length > 0) {
      var reportName = '醫令用量統計表';
      const printContents = this.getHtml();
      var ret = await this.localPrintService.printHtml(444, reportName, printContents); // urlEncode 'Order Dosage Statistics'
      if (ret.Successed) {
        this.notification.showSuccess(reportName + '已送出列印!', true);
      } else {
        this.notification.showError(reportName + '送出列印失敗!');
      }
    } else {
      this.notification.showInfo('查無資料可供列印!');
    }
  }

  async exportAsExcel() {
    this.exportContainer = document.getElementById("exportContainer");
    if (this.listItems.length > 0) {
      this.exportListData();
      var reportName = '醫令用量統計表';
      const table = this.reportContainer2.nativeElement;
      console.log(table.innerHTML);
      await this.hcrService.ExportTableToExcel(reportName, table.innerHTML);
    } else {
      this.notification.showInfo('查無資料可供匯出!');
    }
  }

  async exportAsExcelInZip() {
    if (this.listItems.length > 0) {
      const uri = 'data:application/zip;base64,';
      const template = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
                                <head>
                                    <!--[if gte mso 9]>
                                    <xml>
                                        <x:ExcelWorkbook>
                                            <x:ExcelWorksheets>
                                                <x:ExcelWorksheet >
                                                    <x:Name>{worksheet}</x:Name>
                                                    <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>
                                                </x:ExcelWorksheet>
                                            </x:ExcelWorksheets>
                                        </x:ExcelWorkbook>
                                    </xml>
                                    <![endif]-->
                                </head>
                                <body>
                                    <table>{table}</table>
                                </body>
                                </html>`;
      const base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) };
      const format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) };
      const table = this.reportContainer.nativeElement;
      const ctx = { worksheet: '醫令用量統計表', table: table.innerHTML };
      const fileName = `醫令用量統計表_` + this.onGetTimeString(new Date(), '');

      // 產生Excel > 壓縮 > 加密碼
      try {
        // The content of the Excel
        // var xlsContent = format(template, ctx);
        // const output = fs.createWriteStream(fileName + '.zip');
        // const archive = archiver('zip');
        // archive.pipe(output);

        // const encryptTransform = new Transform({
        //     transform(chunk, encoding, callback) {
        //         // Encrypt the chunk using the given encryption key
        //         const encryptedChunk = CryptoJS.AES.encrypt(xlsContent, 'aa1234').toString();
        //         this.push(encryptedChunk);
        //         callback();
        //     },
        // });
        // archive.appendChild()

        var xlsContent = format(template, ctx);
        // var encryptedZipContent = CryptoJS.AES.encrypt(xlsContent, 'aa1234').toString();
        let zip = new JSZip();
        zip.file(fileName + `.xls`, xlsContent);
        const options: JSZip.JSZipGeneratorOptions<'blob'> = {
          type: 'blob',
          compression: 'DEFLATE',
        };
        var zipContent = await zip.generateAsync(options);
        // var encryptedZipContent = CryptoJS.AES.encrypt(zipContent, 'aa1234').toString();
        const link = document.createElement('a');
        link.download = fileName + `.zip`;
        // link.href = uri + encryptedZipContent;
        // link.href = uri + zipContent;
        link.href = window.URL.createObjectURL(zipContent);
        link.click();

        // zip.generateAsync({type: "base64"})
        // .then(function(content) {
        //     const link = document.createElement('a');
        //     link.download = fileName + `.zip`;
        //     link.href = uri + content;
        //     link.click();
        // });

        /*
        let zip = new JSZip();
        // 將網頁報表轉為Excel格式後用JSzip壓縮
        var xlsContent = format(template, ctx);
        zip.file(fileName + `.xls`, format(template, ctx));

        zip.generateAsync({type: "base64"})
            .then(function(content) {
                // var CryptoJS = require("crypto-js");
                // var encryptedZipContent = CryptoJS.AES.encrypt(content, "a1234");

                const link = document.createElement('a');
                link.download = fileName + `.zip`;
                link.href = uri + content;
                link.click();
            });
            */
      } catch (e) {
        this.notification.showError(e);
      }


      // var zipContent = zip.generateAsync({type:"blob"});
      // 加密
      // var CryptoJS = require("crypto-js");
      // var encryptedZipContent = CryptoJS.AES.encrypt(zipContent, "aa1234")

      // const link = document.createElement('a');
      // link.download = `醫令用量統計表_` + this.onGetTimeString(new Date(), '') + `.zip`;

      // link.href = uri + base64(encryptedZipContent);
      // link.click();
    } else {
      this.notification.showInfo('查無資料可供匯出!');
    }
  }

  /** 轉換Date To String
   *  [參數] ev:值，isRoc:是否轉換成民國年，symbol:分隔符號，isMonth:是否只顯示到月份
   */
  onGetDateString(ev, isRoc: boolean = false, symbol = '/', isMonth = false) {
    if (ev) {
      var d = new Date(ev);
      var month = '' + (d.getMonth() + 1);
      var day = '' + d.getDate();
      var year = isRoc ? (d.getFullYear() - 1911) : d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      if (isMonth) {
        return [year, month].join(symbol);
      } else {
        return [year, month, day].join(symbol);
      }
    }
  }

  /** 轉換Time To String
      *  [參數] ev:值，isRoc:是否轉換成民國年，symbol:分隔符號，isMonth:是否只顯示到月份
  */
  onGetTimeString(ev, timeSymbol = ':') {
    if (ev) {
      var d = new Date(ev);
      // 趕時間先簡單寫
      let hr = d.getHours().toString();
      if (d.getHours() < 10) {
        hr = '0' + hr;
      }
      let min = d.getMinutes().toString();
      if (d.getMinutes() < 10) {
        min = '0' + min;
      }
      let sec = d.getSeconds().toString();
      if (d.getSeconds() < 10) {
        sec = '0' + sec;
      }
      var timeStr = [hr, min, sec].join(timeSymbol);
      return timeStr;
    }
  }

  onGetDate(ev) {
    if (ev) {
      var d = new Date(ev);
      var month = '' + (d.getMonth() + 1);
      var day = '' + d.getDate();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [month, day].join('');
    }
  }

  formatFloat(num: any, pos: any) {
    const size = Math.pow(10, pos);
    return Math.round(num * size) / size;
  }
}
